import { ReactElement, isValidElement } from 'react';

import { Theme } from '@mui/material';
import { CartesianGridProps } from 'recharts';
import { GridLineTypeFunctionProps } from 'recharts/types/cartesian/CartesianGrid';

import { GridLineGenerator } from './types';
import { getThemeColor } from '../../../../utils';

const buildLineGenerator = (
  props: GridLineTypeFunctionProps,
  lineGenerator: GridLineGenerator,
  theme: Theme
): ReactElement<SVGElement> => {
  const { x1, x2, y1, y2, x, y, key, index, width, height, className } = props;
  const grid = lineGenerator({
    chartDimensions: {
      height,
      width,
    },
    x1,
    x2,
    y1,
    y2,
    currentPoint: { x, y },
    key,
    index,
  });

  if (isValidElement(grid)) {
    return grid;
  }
  const stroke = grid.stroke ? getThemeColor(theme, grid.stroke) : undefined;

  return (
    <line
      x1={x1}
      x2={x2}
      y1={y1}
      y2={y2}
      key={key}
      data-testid="chart-grid-line"
      className={className}
      {...grid}
      stroke={stroke}
    />
  );
};

export const buildGridConfig = (
  theme: Theme,
  hideLine?: boolean,
  lineGenerator?: GridLineGenerator
): Exclude<CartesianGridProps['vertical' | 'horizontal'], ReactElement> => {
  if (hideLine) {
    return false;
  }

  if (!lineGenerator) {
    return undefined;
  }

  return (props) => buildLineGenerator(props, lineGenerator, theme);
};
